const PaymentChannelsFormMode = {
  CREATE: 'create',
  EDIT: 'edit',
};

export { PaymentChannelsFormMode };
